// src/axios.js
import axios from 'axios';
import { create } from 'apisauce'
import { restoreProblemClassification } from '@/api/utils'
/*
const ApiIntegrationClient = axios.create({
  baseURL: 'https://integration-dealcloud.insight.qualitasfunds.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});*/


const ApiIntegrationClient = create({
  baseURL: 'https://integration-dealcloud.insight.qualitasfunds.com/api',
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

restoreProblemClassification(ApiIntegrationClient)

export default ApiIntegrationClient;
